module.exports = __webpack_public_path__ + "img/cta.096521ce.png";